import { Box, Button } from '@mui/material';
import { useUserAnalytics } from '../hooks/useUserAnalytics';
import { AUTH_EVENTS } from '../utils/eventSchema';

const backendUrl = import.meta.env.VITE_BACKEND_URL || '';

function MicrosoftIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21" aria-hidden>
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

const MicrosoftSignIn = ({ fullWidth = true, sx = {}, disabled = false, rememberMe = false }) => {
  const { trackEvent } = useUserAnalytics();

  const handleClick = () => {
    if (!backendUrl) {
      return;
    }
    trackEvent('auth', {
      ...AUTH_EVENTS.LOGIN_STARTED,
      login_method: 'microsoft',
      attempt_time: new Date().toISOString(),
      device: navigator.userAgent,
    });
    window.location.href = `${backendUrl}/auth/microsoft/start${rememberMe ? '?remember_me=1' : ''}`;
  };

  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto', ...sx }}>
      <Button
        variant="outlined"
        fullWidth={fullWidth}
        onClick={handleClick}
        disabled={disabled || !backendUrl}
        sx={{
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.875rem',
          height: 40,
          py: 0,
          px: 2,
          borderColor: '#dadce0',
          color: '#3c4043',
          backgroundColor: '#fff',
          position: 'relative',
          boxShadow: 'none',
          '&:hover': {
            borderColor: '#dadce0',
            backgroundColor: '#f8f9fa',
            boxShadow: 'none',
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: 12,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <MicrosoftIcon />
        </Box>
        Continue with Microsoft
      </Button>
    </Box>
  );
};

export default MicrosoftSignIn;
